import { observable } from 'mobx'
import { Id } from '@/infra/id'
import { unixEpoch } from '@/utils/date-util'
import { Model, type ModelProps } from '@/infra/model'

export type TermsOfUseDocumentProps = ModelProps<TermsOfUseDocument>

/**
 * A version of the terms of use.
 */
export class TermsOfUseDocument extends Model<TermsOfUseDocument> {
  static readonly none = new TermsOfUseDocument()

  id = Id.none
  @observable accessor markup = ''
  @observable accessor dateCreated = unixEpoch()
  @observable accessor dateModified = unixEpoch()
}
